import { render, staticRenderFns } from "./ApprovedDeclinedSelectbox.vue?vue&type=template&id=895e58ca&"
import script from "./ApprovedDeclinedSelectbox.vue?vue&type=script&lang=js&"
export * from "./ApprovedDeclinedSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports